module.exports = __webpack_public_path__ + "static/media/bathtub.94270953.svg";